"use client";

import { createContext, useContext, useMemo, useState } from "react";

/**
 * @typedef {object} ConfigurationContextValue
 * @prop {import("@cloudspire/shared/types/alfred/ChannelConfiguration").ChannelConfiguration} [configuration]
 */

/** @type {ConfigurationContextValue} */
const DEFAULT_VALUES = {
  configuration: undefined,
};

const ConfigurationContext = createContext(DEFAULT_VALUES);

export function useConfiguration() {
  const value = useContext(ConfigurationContext);

  if (value === DEFAULT_VALUES) {
    throw new Error(
      "useConfiguration must be used within a ConfigurationProvider",
    );
  }

  return value;
}

/**
 * @typedef {object} Props
 * @prop {import("@cloudspire/shared/types/alfred/ChannelConfiguration").ChannelConfiguration} [initialConfiguration]
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function ConfigurationProvider({ children, initialConfiguration }) {
  const [configuration] = useState(initialConfiguration);

  const value = useMemo(() => {
    const value = {
      configuration,
    };
    return value;
  }, [configuration]);

  return (
    <ConfigurationContext.Provider value={value}>
      {children}
    </ConfigurationContext.Provider>
  );
}
